import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import defaultLoader from './Icons/proximityLoading.gif'
import { reExportedColors } from './index'
import { getAppIcon } from '../../common/dynamicCustomizationService'

const loader = getAppIcon() || defaultLoader

export default function Loader ({ className }) {
  return (
    <Box
      className={className}
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        left: '50%',
        position: 'fixed',
        top: '50%',
        zIndex: 99
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <img src={loader} height={100} alt='Loading' />
        <CircularProgress
          size={180}
          thickness={2}
          variant='indeterminate'
          sx={{
            color: reExportedColors.PROXIMITY_RED,
            left: -45,
            position: 'absolute',
            top: -45
          }}
        />
      </Box>
    </Box>
  )
}
